import './flightCard.scss';

import CIcon from '@coreui/icons-react';
import React from 'react';

import { useBookingContext } from '../../hooks/useBookingContext';

interface FlightCardProps {
  airlineName: string;
  flightNumber: string;
  origin: string;
  destination: string;
  departureTime: string;
  arrivalTime: string;
  isSelected?: boolean;
}

const FlightCard: React.FC<FlightCardProps> = ({
  airlineName,
  flightNumber,
  origin,
  destination,
  departureTime,
  arrivalTime,
  isSelected,
}) => {
  const { isMobile } = useBookingContext();

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = { weekday: 'short', month: 'short', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  };

  const formatTime = (dateString: string) => {
    const date = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit', hour12: false };
    return date.toLocaleTimeString('en-US', options);
  };

  return (
    <div className={`flight-card ${isSelected ? 'selected' : ''}`} style={{ '--secondary-color': window.tz_globalConfigs?.styling?.secondaryColor } as React.CSSProperties}>
      <div className="flight-card__airline">{`${airlineName} | ${flightNumber}`}</div>
      <div className={`flight-card__details ${!isMobile && 'desktop'} `}>
        <div className="flight-card__details__departure_time">
          <div>{formatTime(departureTime)}</div>
          <div>{formatDate(departureTime)}</div>
        </div>
        <div className="flight-card__details__departure_airport">{origin}</div>
        <div className="flight-card__details__arrow"><CIcon name="cil-arrow-right" /></div>
        <div className="flight-card__details__arrival_time">
          <div>{formatTime(arrivalTime)}</div>
          <div>{formatDate(arrivalTime)}</div>
        </div>
        <div className="flight-card__details__arrival_airport">{destination}</div>
      </div>
    </div>
  );
};

export default FlightCard;
